import { backend, domain } from 'modules/data';
import { RequestEditMode } from 'pages/requestForm/selectors/requestSelectors';

export const getRuleTypeByEditMode = (editMode: RequestEditMode): backend.EditRoleForRequest => {
    switch (editMode) {
        case RequestEditMode.Submitter:
            return backend.EditRoleForRequest.Submitter;

        case RequestEditMode.Editor:
            return backend.EditRoleForRequest.Editor;

        case RequestEditMode.Reviewer:
            return backend.EditRoleForRequest.Reviewer;

        case RequestEditMode.Approver:
            return backend.EditRoleForRequest.Approver;

        case RequestEditMode.ExternalSubmitter:
            return backend.EditRoleForRequest.ExternalSubmitter;
    }
};

export const isFieldMandatory = (documentFieldState: domain.DocumentFieldState) => {
    return documentFieldState === domain.DocumentFieldState.Mandatory;
};

export const isFieldVisible = (documentFieldState: domain.DocumentFieldState) => {
    return documentFieldState !== domain.DocumentFieldState.Hidden;
};

export const isFieldReadOnly = (documentFieldState: domain.DocumentFieldState) => {
    return documentFieldState === domain.DocumentFieldState.ReadOnly;
};

export const isFieldEditable = (documentFieldState: domain.DocumentFieldState) => {
    return (
        documentFieldState === domain.DocumentFieldState.Editable ||
        documentFieldState === domain.DocumentFieldState.Mandatory
    );
};

export const isMandatoryFieldEmpty = (documentFieldState: domain.DocumentFieldState, value: unknown) => {
    return isFieldMandatory(documentFieldState) && (typeof value === 'string' ? !value.trim() : !value);
};
